var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartPageStoreWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.3791e-07C0.447715 1.3791e-07 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H2.7793C2.92489 2 3.0668 2.04581 3.18491 2.13095C3.30302 2.21608 3.39135 2.33622 3.43738 2.47435L6.73438 12.3672C6.88079 12.8064 6.8994 13.2793 6.78711 13.7285L6.51562 14.8164C6.11728 16.4098 7.35758 18 9 18H21C21.5523 18 22 17.5523 22 17C22 16.4477 21.5523 16 21 16H9C8.61061 16 8.36064 15.6805 8.45508 15.3027L8.65981 14.485C8.6945 14.3465 8.7745 14.2235 8.88709 14.1356C8.99969 14.0477 9.13842 14 9.28125 14H20C20.4306 14.0002 20.813 13.7248 20.9492 13.3164L23.6152 5.31641C23.8312 4.66862 23.3489 3.99969 22.666 4H6.55469C6.40909 4 6.26718 3.95419 6.14907 3.86906C6.03095 3.78392 5.94262 3.66379 5.89657 3.52566L4.94922 0.683594C4.81295 0.275155 4.43057 -0.000224972 4 1.3791e-07H1ZM8 19C6.89543 19 6 19.8954 6 21C6 22.1046 6.89543 23 8 23C9.10457 23 10 22.1046 10 21C10 19.8954 9.10457 19 8 19ZM20 19C18.8954 19 18 19.8954 18 21C18 22.1046 18.8954 23 20 23C21.1046 23 22 22.1046 22 21C22 19.8954 21.1046 19 20 19Z",
    fill: "#50429B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartPageStoreWeb);
export default __webpack_public_path__ + "static/media/cart-page-store-web.37c8df7aed71af33e79b043c77b15c19.svg";
export { ForwardRef as ReactComponent };